@let noDataType = dataType();

<i class="text-muted" i18n>
    No {{ noDataType }} results to display yet. Press the 'Parse and Prove'
    button to see the {{ noDataType }} results.
</i>
